<template>
  <div style="height:calc(100vh - 200px);overflow:auto">
    <a-card :bordered="false" style>
      <!-- border-top:1px solid #E7ECEF -->
      <div class="table-page-search-wrapper">
        <!-- <a-form layout="inline">
          <a-row :gutter="24" style="margin:16px 25px;">
            <a-col :span="5">
              <a-form-item label="学员搜索" style="margin-bottom:0px">
                <a-input placeholder="请输入学员" ></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item style="margin-bottom:0px" label="学员来源" :required="false">
                <a-select defaultValue="全部分类">
                  <a-select-option value>全部来源</a-select-option>
                  <a-select-option value="0">线上</a-select-option>
                  <a-select-option value="1">线下</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="9">
              <a-form-item style="margin-bottom:0px" label="签约时间" :required="false">
                <a-date-picker
                  format="YYYY-MM-DD"
                  placeholder="请选择开始日期"
                />至
                <a-date-picker
                  format="YYYY-MM-DD "
                  placeholder="请选择结束日期"
                  @ok="onOk"
                />
              </a-form-item>
            </a-col>

            <a-col :span="4">
              <span style="margin-bottom:0px" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery">筛选</a-button>
              </span>
            </a-col>
          </a-row>
          <a-row :gutter="24" style="margin:16px 25px;">
            <a-col :span="5">
              <a-button>导出学员</a-button>
              <a-button type="primary" style="margin-left:10px">导入学员</a-button>
            </a-col>
          </a-row>
        </a-form>-->
      </div>
      <div style="margin-top:10px;">
        <a-table
          ref="table"
          size="middle"
          rowKey="id"
          :rowSelection="rowSelection"
          :columns="columns"
          :pagination="ipagination"
          :dataSource="dataSource"
          :loading="loading"
        >
          <span slot="action" slot-scope="text, record">
            <a @click="handleEdit(record)">编辑</a>

            <a-divider type="vertical" />
            <!-- <a-dropdown>
              <a class="ant-dropdown-link">
                更多
                <a-icon type="down" />
              </a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                    <a>下架</a>
                  </a-popconfirm>
                </a-menu-item>
                <a-menu-item>
                  <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                    <a>编辑</a>
                  </a-popconfirm>
                </a-menu-item>
                <a-menu-item>
                  <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                    <a>删除</a>
                  </a-popconfirm>
                </a-menu-item>
              </a-menu>
            </a-dropdown> -->
          </span>
        </a-table>
        <div class="fixed-tab-con">
          <div class="fixed-tab">
            <!-- <a-button
              type="primary"
              style="margin-right:10px;height:41px;width:232px;text-align:center;"
            >发送消息</a-button>-->
            <a-button
              type="primary"
              style="height:41px;width:135px;text-align:center;"
              @click="removeFromBlackList()"
            >移除黑名单</a-button>
          </div>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
import { JeecgListMixin } from "@/mixins/JeecgListMixin";
import { removeBlackList } from "@/api/api";
export default {
  name: "BlackStudentList",
  mixins: [JeecgListMixin],
  data() {
    return {
      selectedData: [],
      selectedIds:[],
      // 表头
      description: "黑名单页面",
      columns: [
        {
          title: "学员名称",
          align: "center",
          dataIndex: "realname"
        },
        {
          title: "来源",
          align: "center",
          dataIndex: "source",
          customRender: (text, row, index) => {
              
            return (<span >{row.source == 1 ?'线上':'线下'}</span>)
            
          }
        },
        {
          title: "手机号",
          align: "center",
          dataIndex: "phone"
        },

        {
          title: "拉黑时间",
          align: "center",
          dataIndex: "lockedTime"
        }
      ],
      dataSource: [],
      url: {
        list: "/userInfo/student/blacklist"
        // delete: "/test/jeecgDemo/delete",
        // deleteBatch: "/test/jeecgDemo/deleteBatch",
        // exportXlsUrl: "/test/jeecgDemo/exportXls"
      }
    };
  },
  methods: {
    refreshData:function(){
      this.loadData();
    },
    removeFromBlackList() {
      if (this.selectedIds.length != 0) {
        const param = {
          "idList":this.selectedIds
        }
        removeBlackList(param).then(res=>{
          if(res.success){
            this.searchQuery();
            this.$message.success("已移出黑名单！");
          }
        });
      } else {
        this.$message.warning("请选择至少一条数据");
      }
    }
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
         onChange: (selectedRowKeys, selectedRows) => {
          this.selectedData = [];
          this.selectedIds = [];
          selectedRows.forEach(row => {
            this.selectedData.push(row.phone);
            this.selectedIds.push(row.id);
          });
        },
        getCheckboxProps: record => ({
          props: {
            disabled: record.name === "Disabled User", // Column configuration not to be checked
            name: record.name
          }
        })
      };
    }
  }
};
</script>

<style scoped>
@import "~@assets/less/common.less";
</style>

<style lang="scss" scoped >
.fixed-tab-con {
  // display: none;
  height: 70px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.06);
  position: fixed;
  bottom: 0px;
  left: 0px;
  text-align: center;
  width: 100%;
  // padding-left: 220px;
  .fixed-tab {
    margin-top: 16px;
  }
}
</style>